<template>
  <div class="container-fluid">
    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Ranking de ventas por producto</h1>
          <p class="view-header__subtitle">Productos más vendidos según los filtros aplicados, ordenados por cantidad.</p>
        </div>
      </div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__section-title">
          <i class="bi bi-funnel"></i>
          Filtros
        </div>
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <input v-model="qcode" type="search" class="form-control" placeholder="Buscar por código interno...">
          </div>
          <div class="filters-panel__field">
            <q-select v-model="category_id" :options="categoryFilterOptions" placeholder="Todas las categorías" />
          </div>
          <div class="filters-panel__field">
            <q-select v-model="brand_id" :options="brandFilterOptions" placeholder="Todas las marcas" />
          </div>
          <div class="filters-panel__field filters-panel__field--inline">
            <label class="control-label">Fecha:</label>
            <Daterange :opendir="'left'" :filtered="true" @datepicked="dateCreated"/>
          </div>
          <div class="filters-panel__actions">
            <button type="button" class="filters-panel__btn" @click="clearFilters">
              <i class="bi bi-eraser"></i>
              Limpiar filtros
            </button>
            <button type="button" class="filters-panel__btn" @click="exportPDF">
              <i class="bi bi-filetype-pdf"></i>
              Exportar PDF
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
      />
    </div>
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import Daterange from "../global/Daterange-component.vue";
import QSelect from '@/components/shared/QSelect.vue';
import { mapState } from 'vuex';
import formatMoneyMixin from "../../mixins/formatMoneyMixin";
import formatDateMixin from "../../mixins/formatDateMixin";

export default {
  components: {
    VdtnetTable,
    Daterange,
    QSelect,
  },
  mixins: [formatMoneyMixin, formatDateMixin],
  data: function () {
    return {
      category_id: null,
      brand_id: null,
      qcode: '',
      startDate: null,
      endDate: null,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: {
          url: process.env.VUE_APP_BASE_URL + "/api/reports/rankingProduct",
          type: "GET",
          data: (d) => {
            d.category_id = this.category_id;
            d.brand_id = this.brand_id;
            d.daterange = this.daterange;
            d.qcode = this.qcode;
            return d;
          },
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        },
        processing: true,
        pageLength: 15,
        searching: true,
        searchDelay: 400,
        destroy: true,
        order: [[2, 'desc']],
        ordering: true,
        lengthChange: true,
        serverSide: true,
        autoWidth: false,
      },
      fields: {
        name: {
          label: "Producto",
          render: (data, type) =>
            type === 'display' ? `<span class="data-table__primary">${data || ''}</span>` : data,
        },
        code: { label: "Cód. interno" },
        quantity: { label: "Cantidad", align: "right" },
        total: {
          label: "Total",
          searchable: true,
          align: "right",
          render: this.formatoDinamicoMoneda,
        },
      },
    };
  },
  computed: {
    ...mapState('categories', {
      categories: state => state.categories,
    }),
    ...mapState('brands', {
      brands: state => state.brands,
    }),
    categoryFilterOptions() {
      return [{ value: 'Sin categoria', label: 'Sin categoría' }, ...this.categories.map(cat => ({ value: cat.id, label: cat.name }))];
    },
    brandFilterOptions() {
      return [{ value: 'Sin marca', label: 'Sin Marca' }, ...this.brands.map(brand => ({ value: brand.id, label: brand.name }))];
    },
    daterange() {
      if (this.startDate === null || this.endDate === null) return null;
      const startDate = this.formatoFecha2Daterange(this.startDate);
      const endDate = this.formatoFecha2Daterange(this.endDate);
      return `${startDate} - ${endDate}`;
    },
    filters() {
      return {
        category_id: this.category_id,
        brand_id: this.brand_id,
        daterange: this.daterange,
        qcode: this.qcode,
      };
    },
  },
  watch: {
    category_id() {
      this.refreshTable();
    },
    brand_id() {
      this.refreshTable();
    },
    qcode() {
      this.debouncedRefresh();
    },
  },
  created() {
    this.$store.dispatch('categories/getCategories');
    this.$store.dispatch('brands/getBrands');
  },
  mounted() {
    this.setDefaultDateRange();
  },
  methods: {
    refreshTable() {
      if (this.$refs.table !== undefined) this.$refs.table.reload();
    },
    debouncedRefresh() {
      clearTimeout(this._refreshTimer);
      this._refreshTimer = setTimeout(() => this.refreshTable(), 500);
    },
    dateCreated(date) {
      this.startDate = date.startDate;
      this.endDate = date.endDate;
      this.refreshTable();
    },
    clearFilters() {
      this.category_id = null;
      this.brand_id = null;
      this.qcode = '';
      this.setDefaultDateRange();
      this.refreshTable();
    },
    exportPDF() {
      this.$http.post("/api/reports/PDFRankingProductoReport", this.filters);
    },
    setDefaultDateRange() {
      const today = new Date();
      const startDate = new Date();
      startDate.setDate(today.getDate() - 30);
      this.startDate = this.formatDate(startDate);
      this.endDate = this.formatDate(today);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return `${day}/${month}/${year}`;
    },
  },
};
</script>

<style scoped>
.filters-panel__field--inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filters-panel__field--inline .control-label {
  margin: 0;
  white-space: nowrap;
  font-size: 13px;
  color: var(--text);
}

.filters-panel__field--inline > .form-group {
  flex: 1 1 auto;
  margin-bottom: 0;
}
</style>
